import { apiEndpoint } from '../config/apiEndpoint'

export const buildUrl = (rest) => `${apiEndpoint}${rest}`
